import React, { useState } from 'react';
import ExecutiveDashboard from './components/ExecutiveDashboard';
import AnomalyDashboard from './components/AnomalyDashboard';
import NLA_ComplianceIntelligence from './components/NLA_ComplianceIntelligence';
import NLA_TransactionMonitor from './components/NLA_TransactionMonitor';
import NLA_FraudDetection from './components/NLA_FraudDetection';
import NLA_KYCMonitor from './components/NLA_KYCMonitor';
import './index.css';

const NAV_ITEMS = [
  { id: 'executive',    label: 'Executive',    accent: '#002868', dot: null,      icon: '⊞' },
  { id: 'anomaly',      label: 'Anomaly',      accent: '#BF0A30', dot: null,      icon: '⚠' },
  { id: 'transactions', label: 'Transactions', accent: '#237804', dot: '#52C41A', icon: '⇌' },
  { id: 'fraud',        label: 'Fraud',        accent: '#820014', dot: '#FF4D4F', icon: '◎' },
  { id: 'compliance',   label: 'Compliance',   accent: '#003a8c', dot: '#FAAD14', icon: '✦' },
  { id: 'kyc',          label: 'KYC & Age',    accent: '#391085', dot: '#FAAD14', icon: '⊙' },
];

const COMPONENTS = {
  executive:    ExecutiveDashboard,
  anomaly:      AnomalyDashboard,
  transactions: NLA_TransactionMonitor,
  fraud:        NLA_FraudDetection,
  compliance:   NLA_ComplianceIntelligence,
  kyc:          NLA_KYCMonitor,
};

export default function App() {
  const [activeView, setActiveView] = useState('executive');
  const ActiveComponent = COMPONENTS[activeView];

  return (
    <div style={{ minHeight: '100vh', background: '#0A0E1A', fontFamily: "'IBM Plex Sans', 'Segoe UI', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=IBM+Plex+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        @keyframes pulse-live { 0%,100%{opacity:1} 50%{opacity:0.4} }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
      `}</style>

      <nav style={{
        position: 'sticky', top: 0, zIndex: 1000,
        background: 'rgba(10,14,26,0.97)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.07)', padding: '0 20px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', height: 52, maxWidth: 1600, margin: '0 auto' }}>
          {/* Brand */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginRight: 24, flexShrink: 0 }}>
            <div style={{ width: 30, height: 30, borderRadius: 7, background: 'linear-gradient(135deg, #002868, #40A9FF)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800, fontSize: 11, fontFamily: "'IBM Plex Mono', monospace" }}>NLA</span>
            </div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#F0F0F0', lineHeight: 1, letterSpacing: '-0.01em' }}>Revenue Monitoring System</div>
              <div style={{ fontSize: 9, color: '#595959', fontFamily: "'IBM Plex Mono', monospace", marginTop: 2 }}>GCRMS · Liberia</div>
            </div>
          </div>

          <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,0.07)', marginRight: 20, flexShrink: 0 }} />

          {/* Nav */}
          <div style={{ display: 'flex', gap: 1, flex: 1 }}>
            {NAV_ITEMS.map(item => {
              const isActive = activeView === item.id;
              return (
                <button key={item.id} onClick={() => setActiveView(item.id)} style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '6px 12px', border: 'none', cursor: 'pointer',
                  background: isActive ? `${item.accent}22` : 'transparent',
                  color: isActive ? '#F0F0F0' : '#595959',
                  fontFamily: "'IBM Plex Sans', sans-serif", fontSize: 12,
                  fontWeight: isActive ? 600 : 400, transition: 'all 0.15s',
                  borderBottom: isActive ? `2px solid ${item.dot || '#40A9FF'}` : '2px solid transparent',
                  borderRadius: '6px 6px 0 0',
                }}>
                  <span style={{ fontSize: 13, color: isActive ? (item.dot || '#40A9FF') : '#595959' }}>{item.icon}</span>
                  {item.label}
                  {item.dot && (
                    <span style={{ width: 5, height: 5, borderRadius: '50%', background: item.dot, boxShadow: `0 0 4px ${item.dot}`, marginLeft: 2 }} />
                  )}
                </button>
              );
            })}
          </div>

          {/* Status */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#52C41A', boxShadow: '0 0 6px #52C41A', animation: 'pulse-live 2s infinite' }} />
              <span style={{ fontSize: 10, color: '#52C41A', fontFamily: "'IBM Plex Mono', monospace", fontWeight: 600 }}>LIVE</span>
            </div>
            <div style={{ fontSize: 9, color: '#595959', fontFamily: "'IBM Plex Mono', monospace" }}>DEC 28, 2025 · 14:23 WAT</div>
            <div style={{ background: 'rgba(0,40,104,0.3)', border: '1px solid rgba(64,169,255,0.2)', borderRadius: 4, padding: '2px 7px', fontSize: 9, color: '#40A9FF', fontFamily: "'IBM Plex Mono', monospace" }}>DEMO</div>
          </div>
        </div>
      </nav>

      <main><ActiveComponent /></main>
    </div>
  );
}